import { bootstrapApplication } from "@angular/platform-browser";

import { AppComponent } from "./app/app.component";
import { appConfig } from "./app/app.config";
import { AuthService } from "./app/core/services/auth.service";
import { PostLoginRedirectService } from "./app/core/services/post-login-redirect.service";

bootstrapApplication(AppComponent, appConfig)
  .then((ref) => {
    const auth = ref.injector.get(AuthService);
    const postLoginRedirect = ref.injector.get(PostLoginRedirectService);

    auth.loadUser().subscribe(() => {
      postLoginRedirect.handleRedirect(window.location.pathname);
    });
  })
  .catch((err) => console.error(err));
